import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { combineClasses } from '../theme/theme';

/**
 * 可折叠区块：点击标题展开/收起内容。用于首页、研究、开放位置等页面的长文案折叠展示。
 * Props: label（折叠时显示的标题）, children（展开内容）, defaultOpen, isLight, className；labelClassName（可选，下拉标签文字颜色，如 text-red-400）
 */
const Collapsible = ({ label, children, defaultOpen = false, isLight, className = '', labelClassName = '' }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return (
    <div className={combineClasses('rounded-xl border overflow-hidden', className)}>
      <button
        type="button"
        onClick={() => setIsOpen((o) => !o)}
        className={combineClasses(
          'w-full flex items-center justify-between gap-3 px-4 py-3 text-left font-semibold transition-colors',
          isLight ? 'bg-gray-50 border-gray-200 text-gray-900 hover:bg-gray-100' : 'bg-white/5 border-white/10 text-white hover:bg-white/10'
        )}
        aria-expanded={isOpen}
      >
        <span className={combineClasses('flex-1', labelClassName)}>{label}</span>
        <ChevronDown className={combineClasses('w-5 h-5 flex-shrink-0 transition-transform', isOpen && 'rotate-180')} />
      </button>
      {isOpen && (
        <div className={combineClasses(
          'px-4 py-3 border-t',
          isLight ? 'border-gray-200 bg-white text-gray-700' : 'border-white/10 bg-white/5 text-gray-300'
        )}>
          {children}
        </div>
      )}
    </div>
  );
};

export default Collapsible;
